import { render, staticRenderFns } from "./Alge.vue?vue&type=template&id=eb184802&scoped=true&"
import script from "./Alge.vue?vue&type=script&lang=js&"
export * from "./Alge.vue?vue&type=script&lang=js&"
import style0 from "./Alge.vue?vue&type=style&index=0&id=eb184802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb184802",
  null
  
)

export default component.exports